import React from 'react';

const getHeaderLabel = (header) => {
  const h = header.toLowerCase();
  if (h === 'ltp') return 'LTP';
  if (h === 'change%') return 'Change %';
  if (h === 'change') return 'Change';
  if (h === 'oi') return 'OI';
  if (h === 'oi change%') return 'OI Chg %';
  if (h === 'volume') return 'Vol';
  if (h === 'close') return 'Close';
  if (h === 'bid') return 'Bid';
  if (h === 'ask') return 'Ask';
  if (h === 'iv') return 'IV';
  if (h === 'delta') return 'Delta';
  if (h === 'gamma') return 'Gamma';
  if (h === 'theta') return 'Theta';
  if (h === 'vega') return 'Vega';
  if (h === 'rho') return 'Rho';
  return header.toUpperCase();
};

/**
 * Sticky header row for the Option Chain table.
 * Renders the Call / Strike / Put label row and the column name row.
 * All refs are forwarded from Table so horizontal scroll sync works.
 */
const OptionChainTableHeader = React.forwardRef(function OptionChainTableHeader(
  {
    filteredCallHeaders,
    filteredPutHeaders,
    callTableWidth,
    putTableWidth,
    strikeW,
    ceColWidthPct,
    peColWidthPct,
    ceColgroup,
    peColgroup,
    strikeColgroup,
  },
  refs
) {
  const { ceHeadClipRef, peHeadClipRef, ceHeadTableRef } = refs;

  return (
    <div className="oc-header">
      {/* Call / Put label row */}
      <div className="oc-header-labels">
        <div className="oc-super-header oc-label--ce">Call</div>
        <div className="oc-super-header oc-label--strike" style={{ width: strikeW, minWidth: strikeW }} />
        <div className="oc-super-header oc-label--pe">Put</div>
      </div>

      {/* Column header clips (sync with body clips via applyOffset) */}
      <div className="oc-header-cols">
        <div ref={ceHeadClipRef} className="oc-ce-clip">
          <table ref={ceHeadTableRef} className="oc-table oc-ce-table" style={{ width: callTableWidth, minWidth: callTableWidth }}>
            {ceColgroup}
            <thead>
              <tr style={{ height: '32px' }}>
                {filteredCallHeaders.map((header, i) => (
                  <th key={i} className="oc-th" style={{ width: ceColWidthPct }}>
                    {getHeaderLabel(header)}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>

        <div className="oc-strike-head" style={{ width: strikeW, minWidth: strikeW }}>
          <table className="oc-table" style={{ width: strikeW }}>
            {strikeColgroup}
            <thead>
              <tr style={{ height: '32px' }}>
                <th className="oc-th oc-th--strike">Strike</th>
              </tr>
            </thead>
          </table>
        </div>

        <div ref={peHeadClipRef} className="oc-pe-clip">
          <table className="oc-table oc-pe-table" style={{ width: putTableWidth, minWidth: putTableWidth }}>
            {peColgroup}
            <thead>
              <tr style={{ height: '32px' }}>
                {filteredPutHeaders.map((header, i) => (
                  <th key={i} className="oc-th" style={{ width: peColWidthPct }}>
                    {getHeaderLabel(header)}
                  </th>
                ))}
              </tr>
            </thead>
          </table>
        </div>
      </div>
    </div>
  );
});

export default OptionChainTableHeader;
